import { create } from "zustand";
import { persist } from "zustand/middleware";
import api from "../utils/api";

// Cookie操作のヘルパー関数
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      loading: true,

      // 認証状態の初期化
      init: async () => {
        // 既に初期化済みの場合は何もしない
        if (!get().loading) {
          return;
        }

        try {
          // LocalStorageからトークンを取得
          let token = localStorage.getItem("token");
          
          // LocalStorageにトークンがない場合、クッキーから取得
          if (!token) {
            token = getCookie("auth_token");
            if (token) {
              // クッキーから取得したトークンをLocalStorageに保存
              localStorage.setItem("token", token);
            }
          }
          
          if (token) {
            const response = await api.post("/auth/verify-token", { token });
            if (response.data.valid) {
              set({ user: response.data.user, token, loading: false });
            } else {
              localStorage.removeItem("token");
              deleteCookie("auth_token");
              set({ user: null, token: null, loading: false });
            }
          } else {
            set({ loading: false });
          }
        } catch (error) {
          console.error("認証初期化エラー:", error);
          localStorage.removeItem("token");
          deleteCookie("auth_token");
          set({ user: null, token: null, loading: false });
        }
      },

      // ログイン
      login: async (credentials) => {
        try {
          const response = await api.post("/auth/login", credentials);
          const { user, token } = response.data;

          localStorage.setItem("token", token);
          set({ user, token, loading: false });

          return { success: true };
        } catch (error) {
          console.error("ログインエラー:", error);
          return {
            success: false,
            error: error.response?.data?.error || "ログイン失敗",
          };
        }
      },

      // ログアウト
      logout: async () => {
        try {
          await api.post("/auth/logout");
        } catch (error) {
          console.error("ログアウトエラー:", error);
        } finally {
          localStorage.removeItem("token");
          deleteCookie("auth_token");
          set({ user: null, token: null, loading: false });
        }
      },

      // ユーザー情報の更新
      updateUser: (userData) => {
        set({ user: { ...get().user, ...userData } });
      },

      // ローディング状態の設定
      setLoading: (loading) => {
        set({ loading });
      },
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({ user: state.user, token: state.token }),
    }
  )
);

export default useAuthStore;
